var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2225 6.2025L0 5.25L6.75 0L12.705 4.6275L7.125 10.2075L6.75 10.5L1.2225 6.2025ZM5.25 12.705V12.0825L5.6925 11.6475L5.7225 11.625L1.215 8.1075L0 9.0525L5.25 13.125V12.705ZM14.025 7.935L13.065 6.975C12.9075 6.8175 12.645 6.8175 12.4875 6.975L11.7375 7.725L13.275 9.2625L14.025 8.5125C14.1825 8.355 14.1825 8.0925 14.025 7.935ZM6.75 14.25H8.295L12.8325 9.6975L11.295 8.16L6.75 12.705V14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.1dbd245d.svg";
export { ForwardRef as ReactComponent };